export var domainName;
export var isGityMarketDomain = true;
export var isGityShopDomain = false;
export var isGityMeDomain = false;
export var isSiteDomain = false;

const LOCAL_HOST_STRATEGY_GITY_MARKET = 0; // `Platform`
const LOCAL_HOST_STRATEGY_SITE_DOMAIN = 1;
const LOCAL_HOST_STRATEGY_GITY_SHOP = 2;
const LOCAL_HOST_STRATEGY_GITY_ME = 2;
const LOCAL_HOST_DEFAULT_SHOP_UID = "aminamjadi";

const localDomainStrategy = LOCAL_HOST_STRATEGY_SITE_DOMAIN;

let shopUid = "domain";

// Gity Market
if (
  window.location.host.startsWith("gitymarket.ir") ||
  window.location.host.includes(".gitymarket.ir") ||
  window.location.host.startsWith("gitymarket.com") ||
  window.location.host.includes(".gitymarket.com")
) {
  domainName = "gitymarket";
  isGityMarketDomain = true;
  isGityShopDomain = false;
  isGityMeDomain = false;
  isSiteDomain = false;
}

// Gity Shop
else if (
  window.location.host.startsWith("gity.shop") ||
  window.location.host.includes(".gity.shop")
) {
  domainName = "gityshop";
  isGityMarketDomain = false;
  isGityShopDomain = true;
  isGityMeDomain = false;
  isSiteDomain = false;
}

// Gity Me
else if (
  window.location.host.startsWith("gity.me") ||
  window.location.host.includes(".gity.me")
) {
  domainName = "gityme";
  isGityMarketDomain = false;
  isGityShopDomain = false;
  isGityMeDomain = true;
  isSiteDomain = false;
}

// Localhost
else if (
  window.location.host.startsWith("localhost") ||
  window.location.host.startsWith("192.168")
) {
  domainName = "localhost";
  isGityMarketDomain = localDomainStrategy === LOCAL_HOST_STRATEGY_GITY_MARKET;
  isGityShopDomain = localDomainStrategy === LOCAL_HOST_STRATEGY_GITY_SHOP;
  isGityMeDomain = localDomainStrategy === LOCAL_HOST_STRATEGY_GITY_ME;
  isSiteDomain = localDomainStrategy === LOCAL_HOST_STRATEGY_SITE_DOMAIN;
  shopUid = LOCAL_HOST_DEFAULT_SHOP_UID;
}

// Site Domain
else {
  domainName = window.location.host;
  isGityMarketDomain = false;
  isGityShopDomain = false;
  isGityMeDomain = false;
  isSiteDomain = true;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  domainName,
  isGityMarketDomain,
  isGityShopDomain,
  isGityMeDomain,
};

export function getShopUid() {
  if (isSiteDomain) {
    return shopUid;
  } else {
    return window.location.pathname.split("/")[1];
  }
}

export function getInvoiceCartUid() {
  if (isSiteDomain) {
    return window.location.pathname.split("/")[2];
  } else {
    return window.location.pathname.split("/")[3];
  }
}

export function getProductId() {
  if (isSiteDomain) {
    return window.location.pathname.split("/")[2];
  } else {
    return window.location.pathname.split("/")[3];
  }
}
